<app-calendar-header
  #calendarHeader
  [handleLoading]="handleLoading"
  [onMonthChange]="getCurrentMonthRequests"
  [isCalendarHome]="isCalendarHome()"
/>
<div class="calendar-container">
  @if (isLocalLoading) {
    <div class="shadow">
      <mat-spinner style="z-index: 1" />
    </div>
  }
  <table
    class="table table-striped"
    [class.home-page-calendar]="isCalendarHome()"
    [class.admin-page-calendar]="!isCalendarHome()"
  >
    <thead>
      <tr class="header-row">
        <div class="action-holder">
          @if (isCalendarHome()) {
            <app-calendar-dialog [projectId]="projectId()" [handleSubmit]="resetCalendar" />
          }
          @if (!isCalendarHome()) {
            <div class="new-form">
              <mat-form-field
                appearance="fill"
                class="form-item-full no-padding"
                subscriptSizing="dynamic"
              >
                <mat-label>{{ 'ADMIN.CLIENT_HOURS.PROJECTS' | translate }}</mat-label>
                <input
                  type="text"
                  matInput
                  placeholder="{{ 'ADMIN.CLIENT_HOURS.PROJECTS' | translate }}"
                  #filter
                  [formControl]="projectsControl"
                  [matAutocomplete]="auto"
                />
                <mat-autocomplete
                  #auto="matAutocomplete"
                  (optionSelected)="onProjectChange($event)"
                  (opened)="markSelectedProjectOption()"
                  [displayWith]="displayFn"
                >
                  @for (project of projectList() | filter: projectFilterText() : 'name'; track project) {
                    <mat-option [value]="project">
                      {{ project.name }}
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>
          }
          <mat-form-field class="calendar-search-field" appearance="fill">
            <mat-icon matPrefix>search</mat-icon>
            <input
              id="search-term"
              type="search"
              placeholder="{{ 'SHARED.SEARCH' | translate }}"
              (ngModelChange)="applyFilter($event)"
              [(ngModel)]="filter"
              autocomplete="off"
              matInput
            />
          </mat-form-field>
          @if (isCalendarHome()) {
            <mat-form-field class="leave-type-filter" appearance="fill" subscriptSizing="dynamic">
              <mat-label>{{ 'HOME.CALENDAR.LEAVE_TYPE_FILTER' | translate }}</mat-label>
              <mat-select
                id="leave-type-filter"
                multiple
                [value]="selectedLeaveTypes"
                (selectionChange)="onLeaveTypesChange($event.value)"
              >
                <mat-select-trigger>
                  @for (type of selectedLeaveTypes; track type) {
                    {{ (`VACATION_TYPES.${type}` | translate) + ($last ? '' : ',') }}
                  }
                </mat-select-trigger>
                @for (type of leaveTypes; track type) {
                  <mat-option [value]="type">
                    <span class="leave-type-option">
                      <span class="leave-type-icon" [class]="type.toLowerCase()">
                        <mat-icon aria-hidden="true">{{ type | vacationTypeToIcon }}</mat-icon>
                      </span>
                      {{ `VACATION_TYPES.${type}` | translate }}
                    </span>
                  </mat-option>
                }
              </mat-select>
              @if (selectedLeaveTypes.length) {
                <button
                  matSuffix
                  mat-icon-button
                  type="button"
                  [attr.aria-label]="'HOME.CALENDAR.CLEAR_LEAVE_TYPE_FILTER' | translate"
                  (click)="clearLeaveTypes(); $event.stopPropagation()"
                >
                  <mat-icon>close</mat-icon>
                </button>
              }
            </mat-form-field>
          }
        </div>
        @for (day of daysDetails; track day) {
          <th class="day" [class.weekend]="day.isWeekend" [class.today]="day.isToday" scope="col">
            <div class="day-name">
              {{ day.header }} <span>{{ day.date }}</span>
            </div>
          </th>
        }
      </tr>
    </thead>

    <tbody>
      <ng-container>
        @for (emp of currentPageData; track emp) {
          <tr>
            <td class="employee-name">
              <div class="employee-details">
                <a id="link" [routerLink]="['/dreamix/page/employees', emp.id]">
                  {{ emp.fullName }}
                </a>
                <mat-icon
                  [matTooltip]="
                    isCalendarHome()
                      ? 'Work days: ' + emp.workDays
                      : 'Work days: ' +
                        emp.workDays +
                        '\n' +
                        'Total Working Hours: ' +
                        emp.totalWorkingHours +
                        '\n' +
                        'Month Working Hours: ' +
                        emp.totalMonthWorkingHours
                  "
                  [matTooltipPosition]="'after'"
                  matTooltipClass="multiline-tooltip"
                  class="info-icon"
                  >info_outlined
                </mat-icon>
                @if (!isCalendarHome()) {
                  <mat-icon class="employee-expand-icon" (click)="expandEmployee(emp.id)"
                    >open_in_full</mat-icon
                  >
                }
              </div>
            </td>

            @for (day of daysDetails; track day.fullDateString) {
              @let employeeDay = emp.days[day.fullDateString];
              <td
                class="day-cell"
                [class.today]="day.isToday"
                [class.weekend]="day.isWeekend"
                [class.holiday]="isHolidayForEmployee(day, emp.employmentType)"
              >
                <div
                  class="timeslot morning"
                  [class]="employeeDay.morning?.leaveType?.toLowerCase()"
                  [class.requested]="employeeDay.morning?.vacationType"
                  [class.logged]="employeeDay.morning?.loggedTime > 0"
                  [class.work]="employeeDay.morning?.subType === 'WORK'"
                  [style.--logged-width]="employeeDay.morning?.loggedTime * 12.5 + '%'"
                >
                  @if (employeeDay.morning?.icon) {
                    <mat-icon class="icon">
                      {{ employeeDay.morning?.leaveType | vacationTypeToIcon }}
                    </mat-icon>
                  }
                </div>
                <div
                  class="timeslot afternoon"
                  [class]="employeeDay.afternoon?.leaveType?.toLowerCase()"
                  [class.requested]="employeeDay.afternoon?.vacationType"
                  [class.logged]="employeeDay.afternoon?.loggedTime > 0"
                  [class.work]="employeeDay.afternoon?.subType === 'WORK'"
                  [style.--logged-width]="employeeDay.afternoon?.loggedTime * 12.5 + '%'"
                >
                  @if (employeeDay.afternoon?.icon) {
                    <mat-icon class="icon">
                      {{ employeeDay.afternoon?.leaveType | vacationTypeToIcon }}
                    </mat-icon>
                  }
                </div>
              </td>
            }
          </tr>
        }
      </ng-container>
    </tbody>
  </table>
</div>
<div>
  <div [hidden]="isFiltered()" class="calendar-footer">
    <div>
      <mat-label class="page-size-label">{{ 'SHARED.ITEMS_PER_PAGE' | translate }}</mat-label>
      <mat-form-field appearance="fill" class="page-size-dropdown">
        <mat-select
          [(value)]="pageSize"
          (selectionChange)="onPageSizeChange($event)"
          class="page-size-option"
        >
          @for (size of pageSizeOptions; track size) {
            <mat-option [value]="size" class="page-size-option">{{ size }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <mat-paginator
      #paginator
      [length]="calendar.length"
      [pageSize]="pageSize"
      hidePageSize
      showFirstLastButtons
      (page)="onPageChange($event)"
    />
  </div>
</div>
